var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g5, _g6, _g7, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderShops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 210,
    viewBox: "0 0 223 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.914 132.895V127.815L208.171 125.744L137.223 179.451L127.459 186.841V191.928L130.201 194L210.914 132.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.434 158.63V153.549L206.692 151.478L159.97 186.84V191.928L162.713 193.999L173.48 185.852L209.434 158.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.17 132.895V126.278L166.458 121.197V68.1394L163.716 66.061L128.671 92.5898L114.259 81.678L89.874 100.138L72.2868 44.6128L68.2382 47.6799L40.2588 84.6441V137.694V137.702L33.54 142.782V149.4L90.0111 192.152L92.4576 194L94.9041 192.152L173.17 132.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4564 191.928V186.84L10.7351 151.478L8 153.549V158.63L43.9539 185.852L54.714 193.999L57.4564 191.928Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.66 106.778V116.051L153.533 111.411L159.66 106.778Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.66 78.3655V98.861L148.308 107.456L134.769 97.2084L159.66 78.3655Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.1368 104.476V104.483L47.0499 132.556V83.6485L68.5486 55.2434L84.1368 104.476Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M173.17 126.278L114.26 81.6785L33.5474 142.783L92.4577 187.382L173.17 126.278Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.913 127.815V132.895L130.201 194V188.919L132.648 187.064L140.969 180.771L210.913 127.815Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M210.914 127.815L140.969 180.772L132.648 187.065L130.201 188.919L127.459 186.841L137.23 179.451L208.178 125.744L210.914 127.815Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M209.434 153.55V158.63L173.48 185.852L162.713 193.999V188.919L165.159 187.064L173.48 180.771L209.434 153.55Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M209.434 153.55L173.48 180.771L165.159 187.064L162.713 188.919L159.97 186.841L206.692 151.471L209.434 153.55Z",
    fill: "url(#paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.17 126.278V132.896L94.9041 192.152L92.4576 194V187.382L94.9041 185.527L168.905 129.511L173.17 126.278Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.458 121.197V126.278L162.41 129.345V104.7L159.667 106.778L153.54 111.411L131.486 128.104V152.749L127.43 155.816V131.171L124.688 133.249L96.5063 154.582V179.227L92.4505 182.294V124.149L68.2383 47.6802L72.2941 44.613L89.8813 100.139L95.4527 117.74L96.5135 121.089L166.458 68.1324V121.197ZM162.41 100.933V76.2874L159.667 78.3658L134.777 97.2087L131.493 99.6985V120.194V124.344L162.41 100.933ZM127.43 127.411V102.766L124.688 104.837L96.5063 126.17V146.672V150.822L124.688 129.489L127.43 127.411Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M166.458 68.1325L96.5134 121.089L95.4525 117.74L128.678 92.5901L163.716 66.0613L166.458 68.1325Z",
    fill: "url(#paint3_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.713 188.919V194L159.97 191.921V186.841L162.713 188.919Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M162.41 104.7V129.345L159.667 127.274V116.052V106.778L162.41 104.7Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.41 76.2874V100.933L159.667 98.8613V78.3658V78.3586L162.41 76.2874Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.41 100.933L131.486 124.344V120.194L148.308 107.456L159.667 98.8613L162.41 100.933Z",
    fill: "url(#paint4_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.201 188.919V194L127.459 191.921V186.841L130.201 188.919Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M127.43 131.178V155.823L124.695 153.745V133.249L127.43 131.178Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M127.43 102.765V127.411L124.695 125.339V104.837L127.43 102.765Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.43 127.411L124.695 129.489L96.5134 150.822V146.673L124.695 125.34L127.43 127.411Z",
    fill: "url(#paint5_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4577 187.382V194L90.0184 192.153L33.5474 149.4V142.783L37.8125 146.016L90.0184 185.528L92.4577 187.382Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4576 124.156V182.301L89.7224 180.223V122.085L84.1439 104.476L68.5485 55.2433L68.0433 53.634L43.0012 86.7156V144.854L40.2588 142.783V137.702V84.6372L68.2381 47.6802L92.4576 124.156Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0433 53.6343L68.5485 55.2436L47.0498 83.6487V132.557V141.787L43.0012 144.854V86.7159L68.0433 53.6343Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4564 186.841V191.921L54.714 194V188.919L57.4564 186.841Z",
    fill: "url(#paint6_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4564 186.841V191.921L54.714 194V188.919L57.4564 186.841Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M57.4564 186.841L54.714 188.919L52.2748 187.064L43.9539 180.771L8 153.55L10.7424 151.471L57.4564 186.841Z",
    fill: "url(#paint7_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M54.714 188.919V193.999L43.9539 185.852L8 158.63V153.55L43.9539 180.771L52.2748 187.064L54.714 188.919Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M162.409 104.7V129.345L159.667 127.274V116.052V106.778L162.409 104.7Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M162.409 76.2874V100.933L159.667 98.8613V78.3658V78.3586L162.409 76.2874Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M127.43 131.178V155.823L124.695 153.745V133.249L127.43 131.178Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M127.43 102.766V127.411L124.695 125.34V104.837L127.43 102.766Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.259 30.9185C121.693 30.9185 127.719 24.8926 127.719 17.4592C127.719 10.0259 121.693 4 114.259 4C106.826 4 100.8 10.0259 100.8 17.4592C100.8 24.8926 106.826 30.9185 114.259 30.9185Z",
    fill: "url(#paint8_linear)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M153.23 32.8933H180.755C182.595 32.8933 184.089 34.3872 184.089 36.2274C184.089 38.0677 182.595 39.5616 180.755 39.5616H153.23C151.39 39.5616 149.896 38.0677 149.896 36.2274C149.896 34.3872 151.39 32.8933 153.23 32.8933Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M144.887 39.5688H172.412C174.252 39.5688 175.746 41.0627 175.746 42.903C175.746 44.7433 174.252 46.2371 172.412 46.2371H144.887C143.047 46.2371 141.553 44.7433 141.553 42.903C141.553 41.0627 143.047 39.5688 144.887 39.5688Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M153.23 46.2444H180.755C182.595 46.2444 184.089 47.7383 184.089 49.5785C184.089 51.4188 182.595 52.9127 180.755 52.9127H153.23C151.39 52.9127 149.896 51.4188 149.896 49.5785C149.896 47.7383 151.39 46.2444 153.23 46.2444Z",
    fill: "url(#paint11_linear)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M52.9676 18.1201H80.4923C82.3326 18.1201 83.8264 19.614 83.8264 21.4543C83.8264 23.2945 82.3326 24.7884 80.4923 24.7884H52.9676C51.1273 24.7884 49.6334 23.2945 49.6334 21.4543C49.6262 19.614 51.1201 18.1201 52.9676 18.1201Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M44.6249 24.7883H72.1496C73.9899 24.7883 75.4838 26.2822 75.4838 28.1225C75.4838 29.9627 73.9899 31.4566 72.1496 31.4566H44.6249C42.7847 31.4566 41.2908 29.9627 41.2908 28.1225C41.2836 26.2822 42.7774 24.7883 44.6249 24.7883Z",
    fill: "url(#paint13_linear)"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.3011 49.7827H33.1806C33.1895 49.7827 27.5797 60.0839 18.3011 49.7827Z",
    fill: "url(#paint14_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.4457 54.3613L29.2515 42.9155C29.2515 42.9155 33.0808 53.8534 19.4457 54.3613Z",
    fill: "url(#paint15_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M210.913 127.815V132.895L130.201 194V188.919L132.648 187.064L140.969 180.771L210.913 127.815Z",
    fill: "url(#paint16_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M209.434 153.55V158.63L173.48 185.852L162.713 193.999V188.919L165.159 187.064L173.48 180.771L209.434 153.55Z",
    fill: "url(#paint17_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M173.17 126.278V132.896L94.9041 192.152L92.4576 194V187.382L94.9041 185.527L168.905 129.511L173.17 126.278Z",
    fill: "url(#paint18_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M166.458 121.197V126.278L162.41 129.345V104.7L159.667 106.778L153.54 111.411L131.486 128.104V152.749L127.43 155.816V131.171L124.688 133.249L96.5063 154.582V179.227L92.4505 182.294V124.149L68.2383 47.6802L72.2941 44.613L89.8813 100.139L95.4527 117.74L96.5135 121.089L166.458 68.1324V121.197ZM162.41 100.933V76.2874L159.667 78.3658L134.777 97.2087L131.493 99.6985V120.194V124.344L162.41 100.933ZM127.43 127.411V102.766L124.688 104.837L96.5063 126.17V146.672V150.822L124.688 129.489L127.43 127.411Z",
    fill: "url(#paint19_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M68.0433 53.6343L68.5485 55.2436L47.0498 83.6487V132.557V141.787L43.0012 144.854V86.7159L68.0433 53.6343Z",
    fill: "url(#paint20_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M57.4564 186.841V191.921L54.714 194V188.919L57.4564 186.841Z",
    fill: "url(#paint21_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.713 188.919V194L159.97 191.921V186.841L162.713 188.919Z",
    fill: "url(#paint22_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M130.201 188.919V194L127.459 191.921V186.841L130.201 188.919Z",
    fill: "url(#paint23_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M92.4577 187.382V194L90.0184 192.153L33.5474 149.4V142.783L37.8125 146.016L90.0184 185.528L92.4577 187.382Z",
    fill: "url(#paint24_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M92.4576 124.156V182.301L89.7224 180.223V122.085L84.1439 104.476L68.5485 55.2433L68.0433 53.634L43.0012 86.7156V144.854L40.2588 142.783V137.702V84.6372L68.2381 47.6802L92.4576 124.156Z",
    fill: "url(#paint25_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M54.714 188.919V193.999L43.9539 185.852L8 158.63V153.55L43.9539 180.771L52.2748 187.064L54.714 188.919Z",
    fill: "url(#paint26_linear)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.409 104.7V129.345L159.667 127.274V116.052V106.778L162.409 104.7Z",
    fill: "url(#paint27_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.409 76.2874V100.933L159.667 98.8613V78.3658V78.3586L162.409 76.2874Z",
    fill: "url(#paint28_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M127.43 131.178V155.823L124.695 153.745V133.249L127.43 131.178Z",
    fill: "url(#paint29_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M127.43 102.766V127.411L124.695 125.34V104.837L127.43 102.766Z",
    fill: "url(#paint30_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 40.6128,
    width: 222.914,
    height: 169.387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i",
    x: 152.533,
    y: 104.778,
    width: 7.12702,
    height: 11.2735,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i",
    x: 133.769,
    y: 76.3655,
    width: 25.8906,
    height: 31.0907,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i",
    x: 46.0499,
    y: 53.2434,
    width: 38.0869,
    height: 79.3131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 92.8002,
    y: 0,
    width: 46.9185,
    height: 46.9185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 33.5461,
    y1: 134.531,
    x2: 173.173,
    y2: 134.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 127.461,
    y1: 157.329,
    x2: 210.916,
    y2: 157.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 159.973,
    y1: 170.196,
    x2: 209.433,
    y2: 170.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 95.4529,
    y1: 93.5764,
    x2: 166.459,
    y2: 93.5764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 131.486,
    y1: 111.602,
    x2: 162.409,
    y2: 111.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 96.5132,
    y1: 138.078,
    x2: 127.433,
    y2: 138.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 54.7173,
    y1: 190.421,
    x2: 57.4575,
    y2: 190.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 8,
    y1: 170.196,
    x2: 57.4576,
    y2: 170.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 100.804,
    y1: 17.4571,
    x2: 127.718,
    y2: 17.4571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 149.893,
    y1: 36.2316,
    x2: 184.093,
    y2: 36.2316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 141.552,
    y1: 42.9048,
    x2: 175.751,
    y2: 42.9048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 149.893,
    y1: 49.5779,
    x2: 184.093,
    y2: 49.5779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 49.6282,
    y1: 21.4534,
    x2: 83.8277,
    y2: 21.4534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 41.2868,
    y1: 28.1264,
    x2: 75.4863,
    y2: 28.1264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 18.3036,
    y1: 52.0691,
    x2: 33.187,
    y2: 52.0691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 19.4469,
    y1: 48.6356,
    x2: 29.7472,
    y2: 48.6356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 130.201,
    y1: 160.907,
    x2: 210.916,
    y2: 160.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 162.713,
    y1: 173.774,
    x2: 209.433,
    y2: 173.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 92.4607,
    y1: 160.139,
    x2: 173.172,
    y2: 160.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 68.2393,
    y1: 113.457,
    x2: 166.459,
    y2: 113.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 43,
    y1: 99.2455,
    x2: 68.5521,
    y2: 99.2455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 54.7173,
    y1: 190.421,
    x2: 57.4575,
    y2: 190.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 159.973,
    y1: 190.421,
    x2: 162.713,
    y2: 190.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 127.461,
    y1: 190.421,
    x2: 130.201,
    y2: 190.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 33.5461,
    y1: 168.392,
    x2: 92.4607,
    y2: 168.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 40.2597,
    y1: 114.991,
    x2: 92.4606,
    y2: 114.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 8,
    y1: 173.774,
    x2: 54.7174,
    y2: 173.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 159.666,
    y1: 117.023,
    x2: 162.409,
    y2: 117.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 159.666,
    y1: 88.6093,
    x2: 162.409,
    y2: 88.6093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 124.693,
    y1: 143.498,
    x2: 127.433,
    y2: 143.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 124.693,
    y1: 115.088,
    x2: 127.433,
    y2: 115.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderShops);
export default __webpack_public_path__ + "static/media/placeholder_shops.9c3dfe34b85228f6ce03e3aa22a78612.svg";
export { ForwardRef as ReactComponent };